<template>
  <div class="pane-con">
    <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      left-arrow
      :right-text="rightText"
      @click-right="onClickRight"
      @click-left="onClickLeft"
    />
    <router-view ref="paneView" />
  </div>
</template>

<script>
export default {
  name: 'Home',
  computed:{
    // 2026-10-02：同一个顶栏根据当前页面提供对应操作，避免筛选条件长期占用列表空间。
    // 例如生成页进入历史记录，历史记录页则从底部打开时间筛选面板。
    rightText(){
      if(this.$route.name === 'actived_code') return '生成记录'
      if(this.$route.name === 'activation_code_history') return '筛选'
      return ''
    }
  },
  methods:{
    onClickLeft(){
      // this.$toast('点左侧')
      this.$router.go(-1)
    },
    // 2026-10-01：仅在分发页显示入口，例如忘记复制后从这里找回生成的码。
    onClickRight(){
      if(this.$route.name === 'actived_code'){
        this.$router.push({name:'activation_code_history'})
        return
      }
      if(this.$route.name === 'activation_code_history'){
        const currentPage = this.$refs.paneView
        if(currentPage && typeof currentPage.openFilter === 'function'){
          currentPage.openFilter()
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.pane-con{

  width: 100vw;
  height: 100vh;
  background-color: #fafafa;
  .head{
    background-color: #2587ee;
    height: 48px;
    color: #fff;
    margin-bottom:15px;
  }
}
</style>
